var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 110,
    viewBox: "0 0 220 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2227,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4453,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.668,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8906,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1094,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 73.332,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5547,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 97.7773,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 122.223,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 134.445,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 146.668,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 158.891,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 171.109,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 183.332,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 195.555,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 207.777,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2227,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4453,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 36.668,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8906,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1094,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 73.332,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5547,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 97.7773,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 122.223,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 134.445,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 146.668,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 158.891,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 171.109,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 183.332,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 195.555,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 207.777,
    y: 12.2222,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2227,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4453,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 36.668,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8906,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1094,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 73.332,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5547,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 97.7773,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 122.223,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 134.445,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 146.668,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 158.891,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 171.109,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 183.332,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 195.555,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 207.777,
    y: 24.4443,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2227,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4453,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 36.668,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8906,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1094,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 73.332,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5547,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 97.7773,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 122.223,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 134.445,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 146.668,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 158.891,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 171.109,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 183.332,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 195.555,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 207.777,
    y: 36.6665,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2227,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4453,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 36.668,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8906,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1094,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 73.332,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5547,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 97.7773,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 122.223,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 134.445,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 146.668,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 158.891,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 171.109,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 183.332,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 195.555,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 207.777,
    y: 48.8887,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2227,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4453,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 36.668,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8906,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1094,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 73.332,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5547,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 97.7773,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 122.223,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 134.445,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 146.668,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 158.891,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 171.109,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 183.332,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 195.555,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 207.777,
    y: 61.1113,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2227,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4453,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 36.668,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8906,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1094,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 73.332,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5547,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 97.7773,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 122.223,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 134.445,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 146.668,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 158.891,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 171.109,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 183.332,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 195.555,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 207.777,
    y: 73.3335,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2227,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4453,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 36.668,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8906,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1094,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 73.332,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5547,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 97.7773,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 122.223,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 134.445,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 146.668,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 158.891,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 171.109,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 183.332,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 195.555,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 207.777,
    y: 85.5557,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2227,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4453,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 36.668,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8906,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1094,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 73.332,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5547,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 97.7773,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 122.223,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 134.445,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 146.668,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 158.891,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 171.109,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 183.332,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 195.555,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#E0E0E0"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 207.777,
    y: 97.7778,
    width: 12.2222,
    height: 12.2222,
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.90ec55811ec200b22a8a950e421b5823.svg";
export { ForwardRef as ReactComponent };